"use client";

import { ChevronRight } from "lucide-react";

type BreadcrumbsProps = {
  items: {
    label: string;
    onClick?: () => void;
  }[];
  className?: string;
};

export default function Breadcrumbs({ items, className = "" }: BreadcrumbsProps) {
  return (
    <div
      className={`flex items-center gap-2 text-[10px] font-mono text-on-surface-variant bg-white/5 w-fit px-3 py-1 rounded-full border border-white/15 ${className}`}
      aria-label="Fil d'ariane"
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const clickable = Boolean(item.onClick);
        return (
          <span key={`${item.label}-${index}`} className="inline-flex items-center gap-2">
            {clickable ? (
              <button
                type="button"
                onClick={item.onClick}
                className={`transition-colors hover:text-white ${isLast ? "text-white" : ""}`}
              >
                {item.label}
              </button>
            ) : (
              <span className={isLast ? "text-white" : ""}>{item.label}</span>
            )}
            {!isLast ? <ChevronRight className="size-3.5" /> : null}
          </span>
        );
      })}
    </div>
  );
}
